import { AbstractControl, ValidationErrors } from "@angular/forms";

export function phoneNumberValidator(
  control: AbstractControl
): ValidationErrors | null {
  if (!control.value) {
    return null; // Let the `required` validator handle empty values.
  }
  const phoneRegex = /^(?:\+234|0)[789]\d{9}$/; // Matches Nigerian phone numbers
  const isValid = phoneRegex.test(control.value);
  return isValid ? null : { invalidPhoneNumber: true };
}
